import { IconButton, PopoverBasicWithTrigger } from "@octopusdeploy/design-system-components";
import { InfoCircleIcon } from "@octopusdeploy/design-system-icons";
import * as React from "react";
import ephemeralEnvironmentChannelInfoImage from "./assets/ephemeral-env-channel-info.svg";
import lifeCycleChannelInfoImage from "./assets/lifecycle-channel-info.svg";
import parentEnvironmentInfoImage from "./assets/parent-environment-info.svg";
export function EphemeralEnvironmentChannelInfoPopover() {
    return (<InfoPopover title="Ephemeral environment channel" description={<>
                    <p>
                        New releases created in this channel will automatically provision a new ephemeral environment based on the environment name template provided (the example above is using branch name). The release is then deployed to that
                        environment.
                    </p>
                    <p>The selected parent environment supplies the deployment targets, accounts, and variables that every ephemeral environment inherits.</p>
                </>} imageSrc={ephemeralEnvironmentChannelInfoImage} imageAltText="Graphic of a release and a parent environment passing values to an ephemeral environment"/>);
}
export function LifecycleChannelInfoPopover() {
    return (<InfoPopover title="Lifecycle channel" description={<p>Releases in this channel will progress through the selected lifecycle.</p>} imageSrc={lifeCycleChannelInfoImage} imageAltText="Graphic of a release being deployed to a staging environment and then to production"/>);
}
export function ParentEnvironmentInfoPopover() {
    return (<InfoPopover title="Parent environment" description={<p>
                    Ephemeral environments are created based on a parent environment, inheriting its scoped deployment targets, variables, and accounts. The parent environment also defines the auto deprovisioning settings, which default to 7 days of
                    inactivity.
                </p>} imageSrc={parentEnvironmentInfoImage} imageAltText="Graphic of ephemeral environments inheriting from a parent environment"/>);
}
interface InfoPopoverProps {
    title: string;
    description: React.ReactNode;
    imageSrc: string;
    imageAltText: string;
}
function InfoPopover({ title, description, imageSrc, imageAltText }: InfoPopoverProps) {
    const handleClick = React.useCallback((e: React.MouseEvent) => {
        e.preventDefault(); // prevent redirect to channel page on row click
    }, []);
    return (<PopoverBasicWithTrigger triggerElement={<IconButton customIcon={<InfoCircleIcon size={16}/>} onClick={handleClick}/>} title={title} description={description} placement={"right-start"} image={imageSrc} altText={imageAltText} width={"wide"} boundaryPadding={100}/>);
}
